import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import BreadcrumbsBasic from '../../../../components/BreadCrumbsBasic';
import { InputField, PathHistoryBreadcrumb } from '../../../../lib/types';
import { ZambdaForms } from '../lib/ZambdaForms';

const prevPaths: PathHistoryBreadcrumb[] = [{ text: 'Zambdas', from: '/zambdas' }];

export function CreateZambda(): JSX.Element {
  const fields: InputField[] = [
    {
      name: 'name',
      label: 'Name',
      placeholder: 'My_New_Zambda',
      required: true,
    },
    {
      name: 'triggerMethod',
      label: 'Trigger method',
      defaultValue: 'http_auth',
      required: true,
      isSelect: true,
    },
    {
      name: 'runtime',
      label: 'Runtime',
      required: false,
      isSelect: true,
      options: ['nodejs22.x', 'nodejs20.x', 'nodejs18.x', 'python3.13', 'python3.12', 'java21', 'dotnet9', 'ruby3.3'],
      helperText: 'Runtime environment for your zambda function. Defaults to nodejs20.x if not specified.',
    },
    {
      name: 'memorySize',
      label: 'Memory (MB)',
      placeholder: '1024',
      required: false,
      helperText: 'Min: 128, Max: 10240 MB. If blank, defaults to 1024MB.',
    },
    {
      name: 'timeoutInSeconds',
      label: 'Timeout (Seconds)',
      placeholder: '27',
      required: false,
      helperText: 'Min: 1, Max: 900. For HTTP triggers (auth/open), max is 27s. If blank, defaults to 27s.',
    },
    {
      name: 'expression',
      label: 'Expression',
      required: false,
      defaultValue: undefined,
      disabled: true,
    },
    {
      name: 'start',
      label: 'Start',
      required: false,
      defaultValue: undefined,
      disabled: true,
    },
    {
      name: 'end',
      label: 'End',
      required: false,
      defaultValue: undefined,
      disabled: true,
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <BreadcrumbsBasic prevPaths={prevPaths} currPathText="Create Zambda"></BreadcrumbsBasic>
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="h4"
          sx={{
            color: 'text.primary',
          }}
        >
          Create Zambda
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ZambdaForms method="create" zambdaFields={fields} />
      </Grid>
    </Grid>
  );
}
